<div class="container">
  <div class="row">
    <div id="actionsContainer" class="col-md d-flex justify-content-between">
      <span>
        <button mat-flat-button (click)="navigateBackToRequest()">
          <mat-icon>arrow_back_ios_new</mat-icon>
          <span>{{ "PAGES.BACK" | translate }}</span>
        </button>
      </span>

      @if (questionnaires.length) {
        <mat-form-field appearance="outline" class="selectList">
          <mat-label>{{ "MENU.ITEMS.QUESTIONNAIRES" | translate }}</mat-label>
          <mat-select [formControl]="activeQuestionnaires" multiple>
            @for (questionnaire of questionnaires; track questionnaire) {
              <mat-option [value]="questionnaire" [disabled]="questionnaire.questionnaireType.name !== 'regular'">
                {{ questionnaire.title }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  </div>

  @if (questionnaires.length) {
    <div>
      @for (questionnaire of activeQuestionnaires.value; track questionnaire) {
        <div style="border-left: var(--darker-outline-color) 2px solid" class="row mb-5">
          @if (questionnaire.questionnaireType.name !== "regular") {
            <div class="col-md-12">
              <h2>{{ "FORMS.REPORT.QUESTIONNAIRE." + questionnaire.questionnaireType.name.toUpperCase() | translate }}</h2>
            </div>
          }
          @if (questionnaire.questionnaireType.name === "regular") {
            <div class="col-md-12">
              <h2>{{ "FORMS.REPORT.QUESTIONNAIRE.TITLE" | translate: { title: questionnaire.title } }}</h2>
              <h4>{{ "FORMS.REPORT.QUESTIONNAIRE.DESCRIPTION" | translate: { description: questionnaire.description } }}</h4>
              <p>{{ "FORMS.REPORT.QUESTIONNAIRE.REMARK" | translate }}</p>
            </div>
          }
          <div class="mt-3">
            <ng-container [ngTemplateOutlet]="formTemplate" [ngTemplateOutletContext]="{ data: questionnaire }"> </ng-container>
          </div>
        </div>
      }
      <button mat-raised-button class="mt-2" (click)="navigateBackToRequest()">{{ "COMPONENTS.DIALOG.BACK" | translate }}</button>
      <button mat-raised-button class="mt-2" (click)="downloadReportAsPDF()">{{ "COMPONENTS.DIALOG.DOWNLOAD_PDF" | translate }} <mat-icon>download</mat-icon></button>
      <button mat-raised-button color="primary" class="mt-2" (click)="openConfirmation()">{{ "COMPONENTS.DIALOG.COMPLETE" | translate }}</button>
    </div>
  } @else {
    <p>{{ (doneLoadingQuestionnaires ? "FORMS.REPORT.ERROR.NO_QUESTIONNAIRES" : "FORMS.REPORT.ERROR.NO_QUESTIONNAIRES_LOADING") | translate }}</p>
  }

  <ng-template #noQuestionnaires>
    <p>{{ (doneLoadingQuestionnaires ? "FORMS.REPORT.ERROR.NO_QUESTIONNAIRES" : "FORMS.REPORT.ERROR.NO_QUESTIONNAIRES_LOADING") | translate }}</p>
  </ng-template>
</div>

<ng-template #formTemplate let-data="data">
  @if (toQuestionnaire(data); as data) {
    <form [formGroup]="returnFormGroup(data.id!)!">
      @for (question of data.questions; track question) {
        <div class="row">
          <div class="col-md">
            @if (question.logic) {
              <div [hidden]="returnFormGroup(data.id!)?.controls?.[question.id!]?.disabled">
                <h5>{{ question.name }}</h5>
                @if (question.questionType.prefix === "sel") {
                  <mat-form-field appearance="outline">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <mat-select [compareWith]="compareOptions" (selectionChange)="saveQuestion(question, data.id!)" [formControlName]="question.id!">
                      @for (selOption of question.options; track selOption) {
                        <mat-option [value]="selOption.id">
                          {{ selOption.value }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "sem") {
                  <mat-form-field appearance="outline">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <mat-select [compareWith]="compareOptions" (selectionChange)="saveQuestion(question, data.id!)" [formControlName]="question.id!" multiple>
                      @for (selOption of question.options; track selOption) {
                        <mat-option [value]="selOption.id">
                          {{ selOption.value }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "txt") {
                  <mat-form-field class="" appearance="outline">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <input matInput (change)="saveQuestion(question, data.id!)" [formControlName]="question.id!" />
                    <app-error [control]="returnFormGroup(data.id!)?.controls?.[question.id!]"></app-error>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "dat") {
                  <mat-form-field class="" appearance="outline">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <input matInput (change)="saveQuestion(question, data.id!)" [formControlName]="question.id!" type="date" />
                    <app-error [control]="returnFormGroup(data.id!)?.controls?.[question.id!]"></app-error>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "trp") {
                  <div>
                    <app-time-range-picker
                      (eventEmitter)="saveTimeRangeInput($event, question, data.id!)"
                      [savedTime]="question.answer?.answer"
                      [control]="$any(returnFormGroup(data.id!)?.controls?.[question.id!])"
                    ></app-time-range-picker>
                  </div>
                }
                @if (question.questionType.prefix === "txa") {
                  <mat-form-field class="" appearance="outline" style="width: 100%">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <textarea
                      matInput
                      (change)="saveQuestion(question, data.id!)"
                      (input)="resize($event)"
                      (click)="resize($event)"
                      style="overflow: hidden; resize: none"
                      [formControlName]="question.id!"
                    ></textarea>
                    <span class="charCounter">
                      <span>{{ returnFormGroup(data.id!)?.controls?.[question.id!]?.value.length ?? 0 }}</span>
                      <span>/ 4500</span>
                    </span>
                    <app-error [control]="returnFormGroup(data.id!)?.controls?.[question.id!]"></app-error>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "upp") {
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <input matInput (change)="saveQuestion(question, data.id!)" [formControlName]="question.id!" type="number" />
                    <app-error [control]="returnFormGroup(data.id!)?.controls?.[question.id!]"></app-error>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "sig") {
                  <app-signature-input
                    (fileSave)="handleSignatureSaved(question, data.id!, $event)"
                    [energyConsult]="energyConsult"
                    [formControl]="$any(returnFormGroup(data.id!)?.controls?.[question.id!])"
                  ></app-signature-input>
                }
              </div>
            }
            @if (!question.logic) {
              <div>
                <h5>{{ question.name }}</h5>
                <p [innerText]="question.description"></p>
                @if (question.questionType.prefix === "sel") {
                  <mat-form-field appearance="outline">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <mat-select [compareWith]="compareOptions" (selectionChange)="saveQuestion(question, data.id!)" [formControlName]="question.id!">
                      @for (selOption of question.options; track selOption) {
                        <mat-option [value]="selOption.id">
                          {{ selOption.value }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "sem") {
                  <mat-form-field appearance="outline">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <mat-select [compareWith]="compareOptions" (selectionChange)="saveQuestion(question, data.id!)" [formControlName]="question.id!" multiple>
                      @for (selOption of question.options; track selOption) {
                        <mat-option [value]="selOption.id">
                          {{ selOption.value }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "txt") {
                  <mat-form-field appearance="outline">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <input matInput (change)="saveQuestion(question, data.id!)" [formControlName]="question.id!" />
                    <app-error [control]="returnFormGroup(data.id!)?.controls?.[question.id!]"></app-error>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "dat") {
                  <mat-form-field appearance="outline">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <input matInput type="date" (change)="saveQuestion(question, data.id!)" [formControlName]="question.id!" />
                    <app-error [control]="returnFormGroup(data.id!)?.controls?.[question.id!]"></app-error>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "trp") {
                  <div>
                    <app-time-range-picker
                      (eventEmitter)="saveQuestion(question, data.id!)"
                      [savedTime]="question.answer?.answer"
                      [control]="$any(returnFormGroup(data.id!)?.controls?.[question.id!])"
                    ></app-time-range-picker>
                  </div>
                }
                @if (question.questionType.prefix === "txa") {
                  <mat-form-field class="" appearance="outline" style="width: 100%">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <textarea
                      matInput
                      (change)="saveQuestion(question, data.id!)"
                      (input)="resize($event)"
                      (click)="resize($event)"
                      style="overflow: hidden; resize: none"
                      [formControlName]="question.id!"
                    ></textarea>
                    <span class="charCounter">
                      <span>{{ returnFormGroup(data.id!)?.controls?.[question.id!]?.value.length ?? 0 }}</span>
                      <span>/ 4500</span>
                    </span>
                    <app-error [control]="returnFormGroup(data.id!)?.controls?.[question.id!]"></app-error>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "upp") {
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>{{ question.placeholder }}</mat-label>
                    <input matInput (change)="saveQuestion(question, data.id!)" [formControlName]="question.id!" type="number" />
                    <app-error [control]="returnFormGroup(data.id!)?.controls?.[question.id!]"></app-error>
                  </mat-form-field>
                }
                @if (question.questionType.prefix === "sig") {
                  <app-signature-input
                    (fileSave)="handleSignatureSaved(question, data.id!, $event)"
                    [question]="question"
                    [energyConsult]="energyConsult"
                    [formControl]="$any(returnFormGroup(data.id!)?.controls?.[question.id!])"
                  ></app-signature-input>
                }
              </div>
            }
            @if (getTotalPriceQuestion(question) !== null) {
              <span class="d-block fst-italic text-muted mb-3">
                {{ "FORMS.REPORT.TOTAL.QUESTION" | translate }}: {{ getTotalPriceQuestion(question) | currency: "EUR" : "symbol" : ".2-2" : "nl" }}
              </span>
            }
          </div>
        </div>
      }
    </form>
    @if (getTotalPrice(data) !== null) {
      <hr />
      <h4>{{ "FORMS.REPORT.TOTAL.QUESTIONNAIRE" | translate }}: {{ getTotalPrice(data) | currency: "EUR" : "symbol" : ".2-2" : "nl" }}</h4>
    }
  }
</ng-template>

<ng-template #confirmationDialog>
  <div class="row">
    <div col-md-4>
      <h3>{{ "FORMS.REPORT.SUCCESS.CONFIRMATION" | translate }}</h3>
      <button mat-raised-button (click)="dialogService.close()">{{ "COMPONENTS.DIALOG.CANCEL" | translate }}</button>
      <button mat-raised-button (click)="saveForm(); dialogService.close()">{{ "COMPONENTS.DIALOG.COMPLETE" | translate }}</button>
    </div>
  </div>
</ng-template>
